module.exports = __webpack_public_path__ + "img/demorris-byrd-K8RAfoZxoYI-unsplash.b935533f.jpg";